import type { ComponentType } from "react";

/**
 * A loading placeholder the size and shape of what a loaded cell shows at
 * rest. `text`, `date`, `dateWithYear`, `number`, `money`, and `rowNumber`
 * are one text bar of that value's typical width; `tag` is a status Tag;
 * `indicator` and `statusIcon` a status dot or icon before a bar; `avatar`
 * is an entity avatar, alone or (`avatarText`) before a bar; `avatarGroup`
 * a stack of avatars; `institutionText` and `fileText` a bank logo or file icon before a bar;
 * `checkbox` an empty row checkbox; `control` a bordered control (input,
 * picker trigger) across the cell; `none` nothing, for cells that show
 * nothing until hovered.
 */
export type DataGridSkeletonPreset =
    | "text"
    | "date"
    | "dateWithYear"
    | "number"
    | "money"
    | "rowNumber"
    | "tag"
    | "indicator"
    | "statusIcon"
    | "avatar"
    | "avatarText"
    | "avatarGroup"
    | "institutionText"
    | "fileText"
    | "checkbox"
    | "control"
    | "none";

export interface DataGridSkeletonProps {
    /** The placeholder row's index, for deterministic widths. */
    rowIndex: number;
}

/**
 * A column's loading placeholder: a preset, or a component that draws one.
 * A component marks its shapes with `DATA_GRID_SKELETON_PROPS` and sizes
 * them itself.
 */
export type DataGridSkeleton =
    | DataGridSkeletonPreset
    | ComponentType<DataGridSkeletonProps>;

/**
 * Spread on an element in a custom skeleton to paint it as a placeholder:
 * the skeleton fill and the sliding sheen. Size and round it yourself.
 */
export const DATA_GRID_SKELETON_PROPS = { "data-dt-skeleton": "" };
